// extracted by mini-css-extract-plugin
export default {"signerDetailsCard":"izvV1RA3JQNROkonYz2P","signerDetailsCardHeader":"xuWnaeCkllTH3ohogP7l","deprecatedNoPaddingGrid":"xmktPKtpf3io4Ore4AFx"};